import styles from "./Title.module.scss";
import { OwnBrand } from "../../utils/product/getOwnBrand";
import { ElementType } from "react";

type Props = {
  /**
   * The title of the product.
   */
  title: string;
  /**
   * The own brand of the product.
   */
  ownBrand: OwnBrand;
  /**
   * Any other brand of the product.
   */
  otherBrand: string;
  /**
   * Used to override the element used to render the component.
   */
  element?: ElementType;
};

export function TitleUI({
  title,
  ownBrand,
  otherBrand,
  element = "h1",
}: Props) {
  const Component = element;
  return (
    <>
      <Component data-testid="product:title" className={styles.title}>
        {ownBrand === "jl_own_brand_anyday_legacy" && (
          <a className={styles.logoAnchor} href="/">
            <span
              data-testid="product:title:anyday"
              className={styles.anydayLogo}
            >
              ANYDAY
            </span>
          </a>
        )}

        {ownBrand === "jl_own_brand_anyday" && (
          <a className={styles.logoAnchor} href="/">
            <span
              data-testid="product:title:anyday"
              className={styles.anydayLogo}
            >
              <span className={styles.titlePrefix}>{`John Lewis `}</span>
              ANYDAY
            </span>
          </a>
        )}

        {ownBrand === "jl_own_brand_john_lewis" && (
          <span
            data-testid="product:title:johnlewis"
            className={styles.johnLewisBrand}
          >
            John Lewis
          </span>
        )}

        {!ownBrand && otherBrand && (
          <span
            data-testid="product:title:otherBrand"
            className={styles.otherBrand}
          >
            {otherBrand}
          </span>
        )}

        {title}
      </Component>
    </>
  );
}
